<span *ngIf="header" class="field-header">{{header}}</span> 
<mat-form-field  
style="width: 100%;"
[ngClass]="header ? 'mt-2' : ''"
[appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input 
  matInput 
  [placeholder]="placeholder ? placeholder : (label ? label : 'Email')"
  [formControl]="controlName" 
  (blur)="onBlurEvent($event)"
  />
  <mat-icon *ngIf="hasError() && !isForgotPassword" matSuffix color="warn">info</mat-icon>
  <mat-icon *ngIf="!hasError() && !isValid()&& !isForgotPassword" color="primary" matSuffix>{{icon ? icon: 'email'}}</mat-icon>
  <mat-icon *ngIf="!isValid() && isForgotPassword" color="primary" matSuffix>email</mat-icon>
  <mat-icon *ngIf="isValid()" matSuffix class="icon-success">check_circle</mat-icon>
  <mat-error *ngIf="hasError() && getErrorMessage() !== 'EmailAlreadyExists'" >{{ getErrorMessage() }}</mat-error>
  <mat-error *ngIf="hasError() && getErrorMessage() === 'EmailAlreadyExists'" >
    Oops, that email address is already in use! Enter a different email or sign in below. Forgot your password? <a class="link" (click)="navigateToResetPasswordUrl()">Reset it now</a>
  </mat-error>
</mat-form-field>
